// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"a1fd09a5","187":"22244add","198":"3b21a35e","453":"fd6424ce","480":"e8f4f015","566":"509ca897","860":"a8f32b66","890":"2ffa5777","984":"e71b8b42"}[chunkId] + ".chunk.js";
};